import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import logger from "redux-logger";
import epicMiddleware, { rootEpic } from "./epics";
import rootReducer from "./reducers";

const applyLogger = process.env.NODE_ENV === "development";

const composeEnhancer = composeWithDevTools({
    name: "Ecommerce Vida Ley",
});

const middlewares: any[] = [epicMiddleware];
if (applyLogger) {
    middlewares.push(logger);
}

export const createStoreWithValue = (defaultValue = {}) =>
    createStore(
        rootReducer,
        defaultValue,
        composeEnhancer(applyMiddleware(...middlewares))
    );

const store = createStoreWithValue();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
epicMiddleware.run(rootEpic as any);

export default store;
